import Tabs from "@/common/components/Tabs";
import { ShowHeader } from "@/common/components/ShowHeader";
import { useNavigate, useParams } from "react-router-dom";
import Button from "@/common/components/Button";
import useTmaisUser from "../../hooks/useTmaisUser";
import BlockUnblockTmaisUser from "../../tabs/users/components/updateUser/DisableEnableTmaisUser";
import { TmaisUserData } from "../../types/tmaisUsers.type";
import { defaultTabs } from "../../constants/TmaisUsersShowTabs.constant";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";

const UsersShow = () => {
  const {id} = useParams()
  const navigate = useNavigate()

  const {
    data: tmaisUser,
    error: tmaisUserError = {} as any,
    refetch: refetchTmaisUsers
  } = useTmaisUser(String(id))

  return (
    <ErrorMessageWrapper
      className="max-h-[calc(100vh-128px)]"
      statusCode={tmaisUserError?.status}
      refetchFunction={refetchTmaisUsers}
    >
      <div className="flex flex-col">
        <ShowHeader
          goBack
          goBackProps={{
            fallback: `/tmais-users`,
            searchLastRouteFromFallback: true,
          }}
          title="Clientes"
          subtitle={(
            <h2 className="text-white-800">
              {tmaisUser?.full_name}
            </h2>
          )}
          buttons={
            <div className="flex items-center gap-2">
              <BlockUnblockTmaisUser tmaisUser={tmaisUser} />
              <Button
                onClick={() => navigate(`edit`)}
                operationKlassToCheckPermission="Admin::Tmais::Users::Update"
              >
                Editar
              </Button>
            </div>
          }
        />

        <Tabs
          tabsListClassName="flex h-auto flex-row flex-wrap justify-start w-full bg-transparent rounded-none"
          tabsTriggerClassName="flex-1 h-8 transition-none duration-0 rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800"
          tabsContentClassName="mt-6"
          tabsList={defaultTabs({tmaisUser: tmaisUser as TmaisUserData})}
        />
      </div>
    </ErrorMessageWrapper>
  );
};

 export default UsersShow;
